import React, { useState, useEffect } from 'react'
import { Header, Content, Row, Col, Progress } from "rsuite";
import { numberFormatter } from '../../utils';
import "./table.scss";
import { CSVLink, CSVDownload } from "react-csv";

const NewTrends = (props: any) => {
    console.log(props);
    props.trendsData.sort((a: any, b: any) => {
        return b.data.sales.fy - a.data.sales.fy
    })
    const [maxValues, setMaxValues] = useState({
        maxNet: 0,
        maxVolume: 0,
        maxGross: 0,
    });
    const [finalData, setFinalData] = useState<any>([]);
    const [exportData, setExportData] = useState<any>([]);

    let csvHeaders = [
        { label: "", key: "name" },

        { label: "Year Till Date (Volume)", key: "volumeNumYtd" },
        { label: "Last 3 Months (Volume)", key: "volumeNumLast3M" },
        { label: "Last Month (Volume)", key: "volumeNumLastM" },
        { label: "Current Month (Volume)", key: "volumeNumCurrMonth" },

        { label: "Year Till Date (Net Cost)", key: "netCostNumYtd" },
        { label: "Last 3 Months (Net Cost)", key: "netCostNumLast3M" },
        { label: "Last Month (Net Cost)", key: "netCostNumLastM" },
        { label: "Current Month (Net Cost)", key: "netCostNumCurrMonth" },

        { label: "Year Till Date (Gross Margin)", key: "grossMarginYtd" },
        { label: "Last 3 Months (Gross Margin)", key: "grossMarginLast3M" },
        { label: "Last Month (Gross Margin)", key: "grossMarginLastM" },
        { label: "Current Month (Gross Margin)", key: "grossMarginCurrMonth" },
      ]

      const prepareExportData = (data: any) => {
        let finalExportData: any = [];
        data.forEach((val: any) => {
          let obj: any = {};
                obj = {
                    name: val?.name,
                    grossMarginCurrMonth: val?.data?.grossMarginNum?.currMonth.toFixed(1),
                    grossMarginLast3M: val?.data?.grossMarginNum?.last3M?.toFixed(1),
                    grossMarginLastM: val?.data?.grossMarginNum?.lastM?.toFixed(1),
                    grossMarginYtd: val?.data?.grossMarginNum?.ytd?.toFixed(1),

                    netCostNumCurrMonth: val?.data?.netCostNum?.currMonth?.toFixed(1),
                    netCostNumLast3M: val?.data?.netCostNum?.last3M?.toFixed(1),
                    netCostNumLastM: val?.data?.netCostNum?.lastM?.toFixed(1),
                    netCostNumYtd: val?.data?.netCostNum?.ytd?.toFixed(1),

                    volumeNumCurrMonth: val?.data?.volumeNum?.currMonth,
                    volumeNumLast3M: val?.data?.volumeNum?.last3M,
                    volumeNumLastM: val?.data?.volumeNum?.lastM,
                    volumeNumYtd: val?.data?.volumeNum?.ytd,
                };
     
                finalExportData.push(obj);
        });
     
        setExportData(finalExportData);        
      };



    const dataProcessor = () => {
        let newSampleData = props.trendsData.length && props.trendsData;
        let maxNetValue: number = 0,
            maxVolumeValue: number = 0,
            maxGrossValue: number = 0;
        newSampleData?.map((d: any) => {
            let netCostObj = d.data.netCost;
            let volumeObj = d.data.volume;
            let grossObj = d.data.grossMargin;
            maxNetValue = Math.max(
                maxNetValue,
                netCostObj.ytd,
                netCostObj.last3M,
                netCostObj.lastM,
                netCostObj.currMonth
            );
            maxVolumeValue = Math.max(
                maxVolumeValue,
                volumeObj.ytd,
                volumeObj.last3M,
                volumeObj.lastM,
                volumeObj.currMonth
            );
            maxGrossValue = Math.max(
                maxGrossValue,
                grossObj.ytd,
                grossObj.last3M,
                grossObj.lastM,
                grossObj.currMonth
            );
        });
        let newData: any = [];
        newSampleData?.map((d: any) => {
            let netCostNum = {
                ytd: d.data.netCost.ytd,
                last3M: d.data.netCost.last3M,
                lastM: d.data.netCost.lastM,
                currMonth: d.data.netCost.currMonth
            };
            let volumeNum = {
                ytd: d.data.volume.ytd,
                last3M: d.data.volume.last3M,
                lastM: d.data.volume.lastM,
                currMonth: d.data.volume.currMonth
            };
            let grossMarginNum = {
                ytd: d.data.grossMargin.ytd,
                last3M: d.data.grossMargin.last3M,
                lastM: d.data.grossMargin.lastM,
                currMonth: d.data.grossMargin.currMonth
            };
            let netCostPercent = {
                ytd: (d.data.netCost.ytd / maxNetValue) * 100,
                last3M: (d.data.netCost.last3M / maxNetValue) * 100,
                lastM: (d.data.netCost.lastM / maxNetValue) * 100,
                currMonth: (d.data.netCost.currMonth / maxNetValue) * 100,
            };
            let volumePercent = {
                ytd: (d.data.volume.ytd / maxVolumeValue) * 100,
                last3M: (d.data.volume.last3M / maxVolumeValue) * 100,
                lastM: (d.data.volume.lastM / maxVolumeValue) * 100,
                currMonth: (d.data.volume.currMonth / maxVolumeValue) * 100,
            };
            let grossMarginPercent = {
                ytd: (d.data.grossMargin.ytd / maxGrossValue) * 100,
                last3M: (d.data.grossMargin.last3M / maxGrossValue) * 100,
                lastM: (d.data.grossMargin.lastM / maxGrossValue) * 100,
                currMonth: (d.data.grossMargin.currMonth / maxGrossValue) * 100,
            };
            newData.push({
                name: d.name,
                data: {
                    netCost: { ...netCostPercent },
                    volume: { ...volumePercent },
                    grossMargin: { ...grossMarginPercent },
                    netCostNum: { ...netCostNum },
                    volumeNum: { ...volumeNum },
                    grossMarginNum: { ...grossMarginNum }
                },
            });
        });

        // newData.sort((a:any,b:any) => {

        // })

        setFinalData([...newData]);
    };
    useEffect(() => {
        // calulateMax();
        dataProcessor();
    }, [props.trendsData]);

    useEffect(()=>{
        if(finalData.length>0){
            prepareExportData(finalData);
        }
    },[finalData])

   return (
    <div className="trends-chart-container-main" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ flex: 1 }} className="show-grid">
            <Col xs={24} sm={24} md={24}  className={`flex flex-col ${props.isVisible ? 'h-[92%]' : 'h-full'}`}>
                <Row style={{ paddingLeft: "2vw" }} className="show-grid">
                    <Col className="font-bold text-[#000] text-fs16 capitalize" xs={24} sm={24} md={9} style={{ textAlign: "center", paddingLeft: "3vw", paddingTop: '1vh' }}>
                        Monthly Avg. Volume (unit)
                    </Col>
                    <Col className="font-bold text-[#000] text-fs16 capitalize" xs={24} sm={24} md={7} style={{ textAlign: "center", paddingLeft: "2vw", paddingRight: "1vw", paddingTop: '1vh' }}>
                        Monthly Avg. Net Cost ($/unit)
                    </Col>
                    <Col className="font-bold text-[#000] text-fs16 capitalize" xs={24} sm={24} md={8} style={{ textAlign: "center", paddingLeft: "2vw", paddingRight: "1vw", paddingTop: '1vh' }}>
                        Monthly Avg. Gross Margin ($/unit)
                    </Col>
                </Row>
                <div style={{ flex: 1, overflow: 'auto', marginBottom: '1vh' }}>
                    <table className="common-table-ui" style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td></td>
                                <td>Year Till Date</td>
                                <td>Last 3 Months</td>
                                <td>Last Month</td>
                                <td>Current Month</td>
                                <td>Year Till Date</td>
                                <td>Last 3 Months</td>
                                <td>Last Month</td>
                                <td>Current Month</td>
                                <td>Year Till Date</td>
                                <td>Last 3 Months</td>
                                <td>Last Month</td>
                                <td>Current Month</td>
                            </tr>
                            {finalData.map((d: any, index: any) => {
                                return (
                                    <tr key={index} className="dataColor">
                                        <td>{d.name}</td>
                                        {Object.keys(d.data.volume).map((volumeData: any, volumeI: number) => {
                                            return (
                                                <td key={volumeI}>
                                                    <span className=''>{numberFormatter(d.data.volumeNum[volumeData], 1)}</span>
                                                    <Progress.Line vertical percent={Math.round(d.data.volume[volumeData] * 10) / 10} strokeColor="rgb(103, 193, 203)" showInfo={false} />
                                                </td>
                                            )
                                        })}
                                        {Object.keys(d.data.netCost).map((netCostData: any, i: number) => {
                                            return (
                                                <td key={i}>
                                                    <span className=" ">{numberFormatter(d.data.netCostNum[netCostData], 1)}</span>
                                                    <Progress.Line vertical percent={Math.round(d.data.netCost[netCostData] * 10) / 10} strokeColor="rgb(107,106,106)" showInfo={false} />
                                                </td>
                                            )
                                        })}
                                        {Object.keys(d.data.grossMargin).map((grossMarginData: any, marginI: number) => {
                                            return (
                                                <td key={marginI}>
                                                    <span className=''>{numberFormatter(d.data.grossMarginNum[grossMarginData], 1)}</span>
                                                    <Progress.Line vertical percent={Math.round(d.data.grossMargin[grossMarginData] * 10) / 10} strokeColor="rgb(193, 122, 1)" showInfo={false} />
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="buttonWrapper mb-[1vh]" style={{ textAlign: 'center' }}>
                    <CSVLink data={exportData} headers={csvHeaders} filename="trends_by_categories.csv" className="submitButton rs-btn" target="_blank">Export Excel</CSVLink>
                </div>
            </Col>
        </div>
    </div>
)

}

export default NewTrends